import { render } from "./ApprovalPathVisualization.vue?vue&type=template&id=c8275a22&scoped=true"
import script from "./ApprovalPathVisualization.vue?vue&type=script&lang=js"
export * from "./ApprovalPathVisualization.vue?vue&type=script&lang=js"

import "./ApprovalPathVisualization.vue?vue&type=style&index=0&id=c8275a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8275a22"]])

export default __exports__